import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { DeviceIdInfo, DeviceIdProvider } from "../DeviceIdProvider.js";
import { PersonalDataStorageInterface } from "../PersonalDataStorageInterface.js";

export class PersonalDataStorageRemoteImpl implements PersonalDataStorageInterface, DeviceIdProvider {

    constructor(private proxy: PostMessageProxyPromise) {

    }
    retrieveOrGenerateDeviceId(): Promise<DeviceIdInfo> {
        return this.proxy.invoke("retrieveOrGenerateDeviceId");
    }

    setWizardCompleted(): void {
        this.proxy.invoke("setWizardCompleted");
    }
    isWizardCompleted(): Promise<boolean> {
        return this.proxy.invoke("isWizardCompleted");
    }
    setNotificationsUnsubscribed(): void {
        this.proxy.invoke("setNotificationsUnsubscribed");
    }
    unsetNotificationsUnsubscribed(): void {
        this.proxy.invoke("unsetNotificationsUnsubscribed");
    }
    isNotificationsUnsubscribed(): Promise<boolean> {
        return this.proxy.invoke("isNotificationsUnsubscribed");
    }
    setCTALastShowed(): void {
        this.proxy.invoke("setCTALastShowed");
    }
    setSexAndRange(sar: string): void {
        this.proxy.invoke("setSexAndRange", sar);
    }
    getCTALastShowed(): Promise<number> {
        return this.proxy.invoke("getCTALastShowed");
    }

    setTrackingOptOut(v: boolean): Promise<void> {
        return this.proxy.invoke("setTrackingOptOut", v);
    }
    getTrackingOptOut(): Promise<boolean> {
        return this.proxy.invoke("getTrackingOptOut");
    }
}